import { Module, VuexModule, MutationAction, getModule, Mutation, Action } from 'vuex-module-decorators';
import store from '@/store';
import { StoreLocator } from '../models';
import { initState } from '../stateinit';
import { setPickupStore, deletePickupStore } from '../api';
import handleError from '@/commons/errorHandler';
import to from 'await-to-js';

let isDeletingStore = false;

@Module({
    namespaced: true,
    name: 'storelocator',
    store,
    dynamic: true,
})
class StorelocatorModule extends VuexModule {
    public stores: StoreLocator[] = initState('storelocators');
    public selectedStoreId = initState('selectedStoreLocatorId');

    get storeById(): any {
        return (id: string) => {
            const retStore = this.stores.find((s: StoreLocator) => parseInt(s.storepickup_id, 10) === parseInt(id, 10));
            return (retStore as StoreLocator);
        };
    }

    @Mutation
    public setSelectedStoreId(selectedStoreId: string) {
        this.selectedStoreId = selectedStoreId;
    }

    @Mutation
    public setStores(stores: StoreLocator[]) {
        this.stores = stores;
    }

    @Action
    public async saveSelectedStore(storeId: string) {
        let err: any;
        [err] = await to(setPickupStore(storeId));
        if (err) {
            handleError(err);
        } else {
            this.setSelectedStoreId(storeId);
        }
        return new Promise((resolve, reject) => {
            if (err) {
                reject();
            } else {
                resolve(true);
            }
        });
    }

    @Action
    public async deleteStore() {
        if (isDeletingStore) {
            return;
        }
        isDeletingStore = true;
        let err: any;
        [err] = await to(deletePickupStore());
        if (err) {
            handleError(err);
        } else {
            this.setSelectedStoreId('');
        }
        return new Promise((resolve, reject) => {
            isDeletingStore = false;
            if (err) {
                reject();
            } else {
                resolve(true);
            }
        });
    }
}

export default getModule(StorelocatorModule);

